import { Logs } from 'components/Logs';

import { BaseProps } from './types';

export function IssueEvents({ issue }: BaseProps): JSX.Element {
  return <Logs logs={issue?.events || []} />;
}
